export default "__VITE_ASSET__C13L1zCj__"